import React from 'react';
import { FileManagerInventoryFile } from '@/redux/slices/slice_types';
import IngestSelections from './IngestSelections';
import { useAppSelector } from '@/redux/hooks';
import { selectCanIngestFiles, selectCanUploadIngestManager } from '@/redux/selectors/authSelectors';
import { useConfigValue } from '@/components/_hooks/useConfigValue';
import FileManagerModal from '@/components/FileManager/FileManagerModal';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedFiles: FileManagerInventoryFile[];
  handleFileSelection: (item: FileManagerInventoryFile) => void;
  resetFiles: () => void;
  onSubmit: () => void;
  singleSelection?: boolean;
}

const IngestFileManagerModal: React.FC<Props> = ({ open, onClose, selectedFiles, handleFileSelection, resetFiles, onSubmit, singleSelection }) => {
  const canIngestFiles = useAppSelector(selectCanIngestFiles);
  const canUpload = useAppSelector(selectCanUploadIngestManager);
  const blurb = useConfigValue(['ingestManagementConfig', 'blurb']);

  let subtractAmount = 0;

  if (selectedFiles.length < 5) {
    const allFilesHeight = selectedFiles.length * 45.5;
    subtractAmount += allFilesHeight;
  } else {
    subtractAmount += 210;
  }

  if (!canIngestFiles) return null;

  return (
    <FileManagerModal
      open={open}
      onClose={onClose}
      selectedFiles={selectedFiles}
      handleFileSelection={handleFileSelection}
      modalTitle={`Ingest File` + (singleSelection ? '' : `s`)}
      canUpload={canUpload}
      canCreateFolder
      blurb={blurb}
      footer={
        /* SELECTED FILES */
        selectedFiles.length > 0 ? (
          <IngestSelections
            selections={selectedFiles}
            removeFile={handleFileSelection}
            clearAll={resetFiles}
            subtractAmount={subtractAmount}
            ingestFiles={onSubmit}
            singleSelection={singleSelection}
          />
        ) : null
      }
    />
  );
};

export default IngestFileManagerModal;
